import { RbacRole } from '@axilon-apps/domains-identity/constants'
import type { EntitiesUserRoleAssignmentResponse } from '@axilon-apps/domains-identity/state'

export const API_KEY_PERMISSION = {
  IngestPush: 'ingest/push'
} as const

export type ApiKeyPermission = (typeof API_KEY_PERMISSION)[keyof typeof API_KEY_PERMISSION]

export const API_KEY_PERMISSION_OPTIONS: ReadonlyArray<{
  value: ApiKeyPermission
  label: string
  description: string
}> = [
  {
    value: API_KEY_PERMISSION.IngestPush,
    label: 'Upload files to intakes',
    description: 'Send files and read upload status for configured intakes.'
  }
]

// Identity grants each permission through a capability role on the
// service-account user; the service_account role itself carries none.
const PERMISSION_BY_ROLE: Readonly<Partial<Record<string, ApiKeyPermission>>> = {
  [RbacRole.IngestUploader]: API_KEY_PERMISSION.IngestPush
}

export function apiKeyPermissions(
  roleAssignments: readonly EntitiesUserRoleAssignmentResponse[] | undefined
): ApiKeyPermission[] {
  const permissions = new Set<ApiKeyPermission>()
  for (const assignment of roleAssignments ?? []) {
    const permission = PERMISSION_BY_ROLE[assignment.role.name]
    if (permission) permissions.add(permission)
  }
  return API_KEY_PERMISSION_OPTIONS.map((option) => option.value).filter((value) =>
    permissions.has(value)
  )
}

export function apiKeyHasPermission(
  permissions: readonly string[] | undefined,
  permission: ApiKeyPermission
): boolean {
  return permissions?.includes(permission) ?? false
}

export function apiKeyPermissionLabel(permission: string): string {
  return (
    API_KEY_PERMISSION_OPTIONS.find((option) => option.value === permission)?.label ?? permission
  )
}
